import consoleLogger from '../../infrastructure/logger/console';
import elasticSearchLogger from '../../infrastructure/logger/elastic-search';
import api from '../../infrastructure/api';
import alert from '../../infrastructure/alert';



// const env = 'development';

const services = {
   log: process.env.NODE_ENV === 'development' ? consoleLogger : elasticSearchLogger,
   api,
   alert
}

export default services;